import { MakeCall } from './createMakeCall';
import { ListingCosts } from './types/Listing';

const getListingCosts = (makeCall: MakeCall) => (listingId: number) =>
  makeCall<ListingCosts>('GET', `/api/v2/listing/${listingId}/costs`);
export { getListingCosts };
